/* ============
 * Adjustment Transformer
 * ============
 */

import Transformer from './transformer';
import productTrans from './adjustmentProduct';
import stockTrans from './stock';
import warehouseTrans from './warehouse';

export default class AdjustmentTransformer extends Transformer {

  static fetch(adj) {
    return {
      id: adj.id,
      stockId: adj.stock_id,
      batchId: adj.batch_id,
      reason: adj.reason,
      total_qty: adj.total_qty,
      code: adj.code,
      warehouseId: adj.warehouse_id,
      warehouseName: adj.warehouse_name,
      createdAt: adj.created_at,
      type: adj.type,
      products: adj.products !== undefined ? productTrans.fetchCollection(adj.products) : [],
      stock: adj.stock !== undefined ? stockTrans.fetch(adj.stock) : [],
      warehouse: adj.warehouse !== undefined ? warehouseTrans.fetch(adj.warehouse) : [],
      status: adj.status,
      adjustmentTypeId: adj.adjustment_type_id,
      adjustmentType: adj.adjustment_type,
    };
  }

  static send(adj) {
    return {
      stock_id: adj.stockId,
      batch_id: adj.batchId,
      warehouse_id: adj.warehouseId,
      products: productTrans.sendCollection(adj.products),
      reason: adj.reason,
      type: adj.type,
      adjustment_type_id: adj.adjustmentTypeId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/adjustment.js